const locale = {
    placeholder: '',
};
export default locale;



// WEBPACK FOOTER //
// ./components/time-picker/locale/zh_CN.tsx